import { Injectable } from '@angular/core';
import { SalesAreaService } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AppState, CmxClientService } from '@cemex/cmx-client-layout';
import { getJobsiteState } from '@ordersnproducts/modules/order-builder/reducers';
import * as filesaver from 'file-saver';
import { TranslateService } from '@ngx-translate/core';
import { SetTermsAction } from '@ordersnproducts/modules/order-builder/modules/summary/actions/summary.actions';

import { getLocationSpecificationState } from '@ordersnproducts/modules/order-builder/reducers';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
@Injectable()
export class SaveTermsConditionsDocumentService {
  public termsAndConditions = {
    approved: false,
    loading: false,
  };

  constructor(
    private store: Store<AppState>,
    private salesAreaService: SalesAreaService,
    private alertService: CmxClientService,
    private translate: TranslateService,
  ) {}

  public saveTermsAndConditionsDocument(locationSpecification: boolean): void {
    this.termsAndConditions.loading = true;
    this.getSalesAreaId(locationSpecification)
      .pipe(
        switchMap((salesAreaId: number) => {
          return this.salesAreaService.getTermsAndConditions(salesAreaId);
        }),
        switchMap((response: any) => {
          if (response === null) {
            this.alertService.addMainAlert(
              'warning',
              this.translate.instant('views.summary.terms_and_conditions_unavailable'),
            );
            return observableOf(null);
          }

          const documentUri = response.links && response.links.salesareaDocument;
          const fileName = response.fileName;
          return this.salesAreaService.getTermsAndConditionsDocument(documentUri).pipe(
            map((data: Blob) => {
              const file = new Blob([data], { type: 'application/pdf' });
              filesaver.saveAs(file, fileName);
              this.termsAndConditions.loading = false;
            }),
          );
        }),
      )
      .subscribe();
  }

  public getSalesAreaId(locationSpecification: boolean): Observable<number> {
    if (locationSpecification) {
      return this.store.select(getLocationSpecificationState).pipe(
        take(1),
        map(locationSpecificationState => {
          return _safe(() => locationSpecificationState.jobsite.selectedSalesArea.salesArea.salesAreaId, 0);
        }),
      );
    } else {
      return this.store.select(getJobsiteState).pipe(
        take(1),
        map(jobsiteState => {
          return _safe(
            () =>
              jobsiteState.jobsiteSalesArea.find(area => {
                return area.jobsite.jobsiteId === jobsiteState.selected.shipmentLocationId;
              }).salesArea.salesAreaId,
            0,
          );
        }),
      );
    }
  }

  public termsAndConditionsChange(value: boolean) {
    if (typeof value === typeof true) {
      // This is because of cmx-checkbox v4 returns value and $event and needs to be refactored.
      // This condition will be removed after the component will be fixed.
      this.termsAndConditions.approved = value;
      this.store.dispatch(new SetTermsAction(value));
    }
  }
}
